import { isInteger, split, size } from 'lodash'
import { range } from './arrayUtils'

function toOption(i) {
  return {
    label: `${i}`.padStart(2, '0'),
    value: i,
  }
}
export function getClockMatrix() {
  const hours = range(12, 24).concat(range(0, 12)).map(toOption)
  const mins = range(0, 60).map(i => i).map(toOption)
  const seconds = range(0, 60).map(i => i).map(toOption)
  return [
    hours,
    mins,
    seconds,
  ]
}

export function checkStringHour(hour) {
  const numberHour = Number(hour)
  return isInteger(numberHour) && numberHour > -1 && numberHour < 24
}

export function checkStringMinuteOrSecond(stringVal) {
  const numberVal = Number(stringVal)
  return isInteger(numberVal) && numberVal > -1 && numberVal < 60
}

export function getTimeObjFromString(timeString) {
  const timeArray = split(timeString, ':')
  const hour = timeArray[0]
  const minute = timeArray[1]
  const second = timeArray[2]
  if (
    size(timeArray) === 3
    && checkStringHour(hour)
    && checkStringMinuteOrSecond(minute)
    && checkStringMinuteOrSecond(second)) {
    return {
      hour: Number(hour),
      minute: Number(minute),
      second: Number(second),
    }
  }
  console.warn('[SingleDatePicker]: props defaultTime is not valid, use default time 12:00:00')
  return {
    hour: 12,
    minute: 0,
    second: 0,
  }
}
